import { render, staticRenderFns } from "./MewtopiaBlock.vue?vue&type=template&id=369a0143&scoped=true"
import script from "./MewtopiaBlock.vue?vue&type=script&lang=js"
export * from "./MewtopiaBlock.vue?vue&type=script&lang=js"
import style0 from "./MewtopiaBlock.vue?vue&type=style&index=0&id=369a0143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a0143",
  null
  
)

export default component.exports